export const uniqueStaffIds = (staffIds) => {
	if (!Array.isArray(staffIds)) return [];

	const seen = new Set();
	const ids = [];
	staffIds.forEach((id) => {
		if (id == null || id === "") return;
		const key = String(id);
		if (seen.has(key)) return;
		seen.add(key);
		ids.push(id);
	});
	return ids;
};

/** Create mode assigns every selected person. Edit and locked staff stay on one entry. */
export const selectedStaffIdsForSave = ({ isEditing, staffLocked, staffId, staffIds }) => {
	if (isEditing || staffLocked) {
		return staffId ? [staffId] : [];
	}
	return uniqueStaffIds(staffIds);
};

const equipmentForStaffCopy = (equipment, recordUsage) =>
	(equipment || []).map((item) => ({
		...item,
		captureUsage: recordUsage ? !!item.captureUsage : false,
		updateCurrentReading: recordUsage ? !!item.updateCurrentReading : false,
	}));

/**
 * One create payload per staff member. Equipment usage is recorded on the first
 * copy only so the same meter reading is not applied once per person.
 */
export const buildStaffTaskPayloads = (basePayload, staffIds, { recordUsageOnFirst = true } = {}) =>
	uniqueStaffIds(staffIds).map((staffId, index) => ({
		...basePayload,
		id: undefined,
		staffId,
		equipment: equipmentForStaffCopy(
			basePayload?.equipment,
			recordUsageOnFirst && index === 0
		),
	}));

export const taskCreateSuccessMessage = (count, { simpleMode, singleMessage }) => {
	if (count <= 1) return singleMessage;
	return simpleMode ? `Created ${count} tasks.` : `Created ${count} schedule entries.`;
};
